import { Link } from "react-router-dom";
import PersonIcon from '@mui/icons-material/Person';

import { IPersonItem } from "~/interfaces";
import { getClassName, getSearchPhotosLink } from "~/utils/utils";
import { getPersonPortraitUrl } from "~/persons/persons-portraits";

import "./style.less";

interface IPersonPhoto {
	person: Pick<IPersonItem, "photoBest" | "key" | "fullName">;
	fullName?: boolean;
	noClick?: boolean;
	className?: string;
}

export default function PersonPhoto({
	person,
	fullName = true,
	noClick = false,
	className = "",
}: IPersonPhoto) {
	// portret ze serveru, jinak nejlepsi fotka z galerie
	const photoSrc = getPersonPortraitUrl(person.key) || person.photoBest?.src || "";
	const curNoClick = !person.photoBest || noClick;
	const content = <>
		{ photoSrc && <img className="personPhoto__img" src={photoSrc} alt="" loading="lazy" draggable={false} /> }
		{ !photoSrc && <span className="personPhoto__defaultCover">
			<PersonIcon />
		</span> }
		{ fullName && <span className="personPhoto__title">{ person.fullName }</span> }
	</>;

	if (curNoClick) {
		return <span className={getClassName(["personPhoto", className, "no-click"])}>
			{ content }
		</span>;
	}

	// odkaz - jde otevrit i do noveho tabu; draggable kvuli posunu rodokmenu tazenim
	return <Link to={getSearchPhotosLink([person])} className={getClassName(["personPhoto", className])} draggable={false}>
		{ content }
	</Link>;
}
